import { BaseModel } from "sjs-base-model";
import configuration from '../../utilities/configuration';
import TaskModel from "../../models/task/TaskModel";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestAllTasks() {
    const endpoint = configuration.apiServer + configuration.apiTasksPath;
    return EffectUtility.getToModel(TaskModel, endpoint);
}

export async function restartTask(taskId) {
    const endpoint = configuration.apiServer + configuration.apiTasksPath + "/" + taskId + "/restart";
    return EffectUtility.putToModel( BaseModel, endpoint);
}

export async function stopTask(taskId) {
    const endpoint = configuration.apiServer + configuration.apiTasksPath + "/" + taskId + "/stop";
    return EffectUtility.putToModel( BaseModel, endpoint);
}
